import { CoordinatorService } from './coordinator.service';
import { SEARCH_ITEM_HELP_DATA } from './search-archive$';

export class Field {
    private _idSet?: Set<string>;
    value = '';

    constructor(
        private coords: CoordinatorService,
        public tag: string,
        public isPreview = false,
    ) {}

    get title() {
        return this.coords.text(`field-${this.tag}`);
    }

    get description() {
        if (this.tag === 'text') return this.coords.text('title-abstract_desc');

        return this.coords.text(`${this.tag}_desc`);
    }

    get isVisible() {
        return !!this.coords.pin$.misc?.has(`show-field-${this.tag}`);
    }

    set isVisible(v: boolean) {
        if (v) {
            this.coords.pin$.misc?.on(`show-field-${this.tag}`);
        } else this.coords.pin$.misc?.off(`show-field-${this.tag}`);
    }

    private _runCutoff() {
        const n = parseInt(this.value.trim());
        const v = isNaN(n) ? 0 : n;
        const f$ = this.coords.field$;
        if (f$.cutoff !== v) {
            f$.cutoff = v;
            this.coords.resultList$.markForCheck();
        }
        return;
    }

    run() {
        // console.log('run', this.tag);
        this._idSet = undefined;
        const v = this.value.trim();
        if (this.tag === 'cutoff') return this._runCutoff();
        if (v.length < 2 || (this.tag === 'year' && v.length < 4)) {
            this.coords.highlight$.setField(this.tag, []);
        } else {
            const h = this.coords.script$.search(this.tag, this.value, this.isPreview);
            this._idSet = h.idSet;
            this.coords.highlight$.setField(this.tag, h.payload);
        }
        this.coords.field$.run();
    }

    get idSet() {
        return this._idSet;
    }

    get isActive() {
        return this._idSet !== undefined;
    }

    save(ls: string[]) {
        if (!this.isActive) return;
        const v = `"${this.value}"`;
        ls.push(`fieldBoard.fillValue("${this.tag}", ${v})`);
    }

    saveRun(ls: string[]) {
        if (!this.isActive) return;
        ls.push(`hitsetLs.push(dt.search("${this.tag}", "${this.value}"))`);
    }

    saveHelp(): SEARCH_ITEM_HELP_DATA | undefined {
        if (!this.isActive) return;
        return { tag: this.tag, value: this.value };
    }

    clear(withRun = false) {
        this._idSet = undefined;
        this.value = '';
        if (this.tag === 'cutoff') return this._runCutoff();
        this.coords.highlight$.setField(this.tag, []);
        withRun && this.coords.field$.run();
    }
}
